import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import Title from '../../../components/Title';
import { useCreateDataVendorUserMutation } from '../../../api/dataVendorUserApiSlice';
import FormButton from '../../../components/forms/FormButton';
import { DataVendorUserForm } from '../../../components/data_vendors/DataVendorUserForm';

export default function DataVendorUserNew(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey: dataVendorId } = useParams();
  const [createUser] = useCreateDataVendorUserMutation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})

  const goToUser = (data) => history.push(`/data_vendors/${dataVendorId}/users/${data.slug}`)

  const handleSubmit = (data) => {
    createUser({dataVendorId, user: data}).unwrap()
      .then(goToUser)
      .catch(error => {})
  }

  const handleBack = () => {
    history.push({
      pathname: `/data_vendors/${dataVendorId}`,
      state: {activeTab: 'users'}
    });
  }

  return (
    <>
      <Title main={t("menu.users")} sub={t('users.new')} group={false} onBack={handleBack}>
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <DataVendorUserForm handleSubmit={handleSubmit} setSubmitButtonProps={setSubmitButtonProps} dataVendorId={dataVendorId} canSelectRole={true}/>
    </>
  )
}




